import type {
  SubscriptionPlanItem,
  SubscriptionPurchaseResult,
} from '@glyphic/user-api-types'

import { resolveWirePublicId } from '../lib/publicId'
import { apiRequest } from './client'

export type Plan = {
  id: string
  code: string
  name: string
  priceYuan: number
  durationLabel: string
  bonusCredits: number
  limitNote?: string
  limitPurchased?: number
  limitMax?: number
  description: string
  features: string[]
  recommended?: boolean
}

function toClientPlan(item: SubscriptionPlanItem & { id?: string; public_id?: string }): Plan {
  const limitMax = item.purchaseLimit
  return {
    id: resolveWirePublicId(item, 'publicId', 'public_id', 'id'),
    code: item.code,
    name: item.name,
    priceYuan: item.priceCents / 100,
    durationLabel: item.durationLabel,
    bonusCredits: item.bonusPoints,
    limitNote: limitMax != null && limitMax > 0 ? '限购' : undefined,
    limitPurchased: item.purchasedCount,
    limitMax: limitMax != null && limitMax > 0 ? limitMax : undefined,
    description: item.description,
    features: item.features,
    recommended: item.recommended,
  }
}

export async function fetchSubscriptionPlans(): Promise<Plan[]> {
  const rows = await apiRequest<SubscriptionPlanItem[]>('/v1/subscription-plans')
  return rows.map(toClientPlan)
}

export async function purchaseSubscriptionPlan(publicId: string) {
  return apiRequest<SubscriptionPurchaseResult>(
    `/v1/subscription-plans/${encodeURIComponent(publicId)}/purchase`,
    { method: 'POST' },
  )
}
